import mixpanel from 'mixpanel-browser'
import { Currency, User } from '../gql/types'

const MIXPANEL_KEY = 'fb012a735cb2ac12beb75a5b79d8ef25'

interface CreateTrackPurchaseInput {
  transactionId: string
  currency: Currency
  priceCents: number
  email: string
}

const trackPurchaseInputDefault = {
  transactionId: null,
  currency: null,
  priceCents: null,
  email: null,
}

export const init = () => {
  mixpanel.init(MIXPANEL_KEY, { debug: false })
}

export const identity = (user: User) => {
  // console.log('Identify', user.id)
  // // @ts-ignore
  // if (window.YourTracker) {
  //   // @ts-ignore
  //   window.YourTracker.identify(user.id, {
  //     email: user.email,
  //     firstName: user.firstName,
  //     lastName: user.lastName,
  //     type: user.type,
  //   })
  // }
}

export const trackEvent = (event: AnalyticsEvent, options: any = {}): void => {
  mixpanel.track(event, options)

  // @ts-ignore
  window.fbq('trackCustom', event)

  // @ts-ignore
  window.gtag('event', event)

  // @ts-ignore - TikTok
  window.ttq.track(event, options)
}

export enum AnalyticsEvent {
  firstPurchase = 'firstPurchase',

  // App
  viewLogin = 'viewLogin',

  // Brands events
  viewBrandsProfile = 'viewBrandsProfile',
  viewBrandsRegister = 'viewBrandsRegister',
  brandSignedUp = 'brandSignedUp',
  startTrial = 'startTrial',
  completeRegistration = 'completeRegistration',
  clickBookOnboardingCall = 'clickBookOnboardingCall',
  clickBookADemoCall = 'clickBookADemoCall',
  brandClickGetInTouch = 'brandClickGetInTouch',
  brandClickBookAnOnboardingCall = 'brandClickBookAnOnboardingCall',
  brandDownloadClip = 'brandDownloadClip',
  viewBrandsTemplates = 'viewBrandsTemplates',

  // Brands onboarding
  viewBrandsOnboardingSetSourceChannel = 'viewBrandsOnboardingSetSourceChannel',
  viewBrandsOnboardingSetWebsite = 'viewBrandsOnboardingSetWebsite',
  viewBrandsOnboardingSetDetails = 'viewBrandsOnboardingSetDetails',
  viewBrandsOnboardingSetBrandIndustry = 'viewBrandsOnboardingSetBrandIndustry',
  viewBrandsOnboardingSetCampaignDetails = 'viewBrandsOnboardingSetCampaignDetails',
  viewBrandsOnboardingSetProductDetails = 'viewBrandsOnboardingSetProductDetails',
  viewBrandsOnboardingSetVideoType = 'viewBrandsOnboardingSetVideoType',
  viewBrandsOnboardingSetModelType = 'viewBrandsOnboardingSetModelType',
  viewBrandsOnboardingSetVoiceType = 'viewBrandsOnboardingSetVoiceType',
  viewBrandsOnboardingSetPlatform = 'viewBrandsOnboardingSetPlatform',
  viewBrandsOnboardingSetVideoDuration = 'viewBrandsOnboardingSetVideoDuration',
  viewBrandsOnboardingSetVideoPlacements = 'viewBrandsOnboardingSetVideoPlacements',
  viewBrandsOnboardingSetRequirements = 'viewBrandsOnboardingSetRequirements',
  viewBrandsOnboardingSetAddons = 'viewBrandsOnboardingSetAddons',
  viewBrandsOnboardingSetHooks = 'viewBrandsOnboardingSetHooks',
  viewBrandsOnboardingSetCreatorDetails = 'viewBrandsOnboardingSetCreatorDetails',
  viewBrandsOnboardingSetOrderSummary = 'viewBrandsOnboardingSetOrderSummary',
  viewBrandsAllReviews = 'viewBrandsAllReviews',

  // Brands collaborations
  viewBrandsCollaborationProfile = 'viewBrandsCollaborationProfile',
  viewBrandsCollaborationReviews = 'viewBrandsCollaborationReviews',
  brandLeftCreatorReview = 'brandLeftCreatorReview',
  brandUpdatedRating = 'brandUpdatedRating',

  // checkout
  initiateCheckout = 'initiateCheckout',
  purchase = 'purchase',

  // Creators events
  viewCreatorsRegister = 'viewCreatorsRegister',
  creatorSignedUp = 'creatorSignedUp',
  creatorAppliedToClip = 'creatorAppliedToClip',
  creatorAppliedToCampaign = 'creatorAppliedToCampaign',
  viewCreatorsOpportunities = 'viewCreatorsOpportunities',
  viewCreatorsInvitations = 'viewCreatorsInvitations',
  creatorWithdrawFromCollaboration = 'creatorWithdrawFromCollaboration',
  creatorAcceptedCampaignInvitation = 'creatorAcceptedCampaignInvitation',
  creatorGetInTouch = 'creatorGetInTouch',

  // Creators onboarding
  viewCreatorsOnboardingSetSourceChannel = 'viewCreatorsOnboardingSetSourceChannel',
  viewCreatorsOnboardingSetProfile = 'viewCreatorsOnboardingSetProfile',
  viewCreatorsOnboardingSetAbout = 'viewCreatorsOnboardingSetAbout',
  viewCreatorsOnboardingSetInterests = 'viewCreatorsOnboardingSetInterests',
  viewCreatorsOnboardingSetIntroVideo = 'viewCreatorsOnboardingSetIntroVideo',
  viewCreatorsOnboardingSetShippingAddress = 'viewCreatorsOnboardingSetShippingAddress',
  viewCreatorsOnboardingSetPaypal = 'viewCreatorsOnboardingSetPaypal',
  viewCreatorsOnboardingSetAgreeTerms = 'viewCreatorsOnboardingSetAgreeTerms',
  viewCreatorsOnboardingSetPortfolio = 'viewCreatorsOnboardingSetPortfolio',
  viewCreatorsOnboardingApplicationCompleted = 'viewCreatorsOnboardingApplicationCompleted',
  viewCreatorsOnboardingApplicationRejected = 'viewCreatorsOnboardingApplicationRejected',

  // Contract signing
  viewContractSigningPage = 'viewContractSigningPage',
  contractSigned = 'contractSigned',

  // Creators collaborations
  viewCreatorsCollaborationView = 'viewCreatorsCollaborationView',
  viewCreatorsCollaborationReviews = 'viewCreatorsCollaborationReviews',
  creatorLeftBrandReview = 'creatorLeftBrandReview',

  // Account Settings
  viewCreatorsProfile = 'viewCreatorsProfile',
  viewCreatorsPersonalInformation = 'viewCreatorsPersonalInformation',
  viewCreatorsEditShippingAddress = 'viewCreatorsEditShippingAddress',
  viewCreatorsEditSocialMedia = 'viewCreatorsEditSocialMedia',
  viewCreatorsEditPassword = 'viewCreatorsEditPassword',
  viewCreatorsEditPaused = 'viewCreatorsEditPaused',

  // Team and Invitations
  teamMemberSignedUp = 'teamMemberSignedUp',
}
/**
 * Tracking complete registration for brands - completed onboarding
 */

export const trackCompleteRegistration = () => {
  // @ts-ignore
  window.fbq('track', 'CompleteRegistration')
  mixpanel.track(AnalyticsEvent.brandSignedUp)

  // @ts-ignore
  window.gtag('event', AnalyticsEvent.brandSignedUp)

  // @ts-ignore
  window.gtag('event', 'complete_registration')

  // @ts-ignore - LinkedIn
  window.lintrk('track', { conversion_id: 19567330 })

  // @ts-ignore - TikTok
  window.ttq.track('CompleteRegistration')
}

/**
 * this is tracking completing the onboarding and getting to checkout page
 */
export const trackAddToCart = () => {
  // @ts-ignore - Facebook
  window.fbq('track', 'AddToCart')

  // @ts-ignore - Google
  window.gtag('event', 'add_to_cart')

  // Mixpanel
  mixpanel.track(AnalyticsEvent.brandSignedUp)

  // @ts-ignore - LinkedIn
  window.lintrk('track', { conversion_id: 19567338 })

  // @ts-ignore - TikTok
  window.ttq.track('AddToCard')
}

export const trackInitiateCheckout = ({
  insertId,
}: { insertId?: string } = {}) => {
  // @ts-ignore - Facebook
  window.fbq(
    'track',
    'InitiateCheckout',
    {},
    insertId ? { eventID: `InitiateCheckout-${insertId}` } : undefined,
  )

  // @ts-ignore - Google
  window.gtag('event', 'begin_checkout')

  // Mixpanel — pass $insert_id so retries from Stripe cancel/back dedupe to one event
  mixpanel.track(
    AnalyticsEvent.initiateCheckout,
    insertId ? { $insert_id: `initiateCheckout-${insertId}` } : undefined,
  )

  // @ts-ignore - LinkedIn
  window.lintrk('track', { conversion_id: 19567346 })

  // @ts-ignore - TikTok
  window.ttq.track(
    'InitiateCheckout',
    {},
    insertId ? { event_id: `InitiateCheckout-${insertId}` } : undefined,
  )
}

export const trackPurchase = (
  input: CreateTrackPurchaseInput = trackPurchaseInputDefault,
) => {
  // @ts-ignore Facebook
  window.fbq('track', 'Purchase', {
    eventID: `Purchase-${input.transactionId}`,
    value: input.priceCents / 100,
    currency: input.currency.toLocaleUpperCase(),
  })

  // Mixpanel — $insert_id dedupes if both the client and the server-side
  // mirror fire (or the React effect double-runs).
  mixpanel.track(AnalyticsEvent.purchase, {
    $insert_id: `purchase-${input.transactionId}`,
    transactionId: input.transactionId,
    value: input.priceCents / 100,
    currency: input.currency.toLocaleUpperCase(),
  })

  // @ts-ignore
  window.gtag('event', 'purchase', {
    transaction_id: input.transactionId, // A unique transaction ID for this purchase.
    affiliation: 'Clip App', // The store or affiliation from which this transaction occurred (if applicable).
    value: input.priceCents / 100, // The total value of the transaction.
    currency: input.currency.toLocaleUpperCase(), // The currency of the transaction.
    tax: 0.0, // The total tax associated with the transaction.
    shipping: 0.0, // The shipping cost associated with the transaction.
  })

  // @ts-ignore LinkedIn
  window.lintrk('track', {
    conversion_id: 19567354,
    transaction_id: input.transactionId, // A unique transaction ID for this purchase.
    value: input.priceCents / 100, // The total value of the transaction.
    currency: input.currency.toLocaleUpperCase(), // The currency of the transaction.
  })

  // @ts-ignore - TikTok
  window.ttq.track(
    'CompletePayment',
    {
      contents: [
        {
          content_id: input.transactionId,
          content_type: 'product',
          content_name: 'purchase',
        },
      ],
      value: input.priceCents / 100,
      currency: input.currency.toLocaleUpperCase(),
    },
    {
      event_id: `purchase-${input.transactionId}`,
    },
  )

  if (input.email) {
    // @ts-ignore
    window.rewardful('convert', { email: input.email })
  }
}

export const trackFirstPurchase = (
  input: CreateTrackPurchaseInput = trackPurchaseInputDefault,
) => {
  // @ts-ignore Facebook
  window.fbq('track', AnalyticsEvent.firstPurchase, {
    eventID: `firstPurchase-${input.transactionId}`,
    value: input.priceCents / 100,
    currency: input.currency.toLocaleUpperCase(),
  })

  // Mixpanel — $insert_id dedupes if both the client and the server-side
  // mirror fire (or the React effect double-runs).
  mixpanel.track(AnalyticsEvent.firstPurchase, {
    $insert_id: `firstPurchase-${input.transactionId}`,
    transactionId: input.transactionId,
    value: input.priceCents / 100,
    currency: input.currency.toLocaleUpperCase(),
  })

  // @ts-ignore
  window.gtag('event', AnalyticsEvent.firstPurchase)

  // @ts-ignore LinkedIn
  window.lintrk('track', {
    conversion_id: 19567362,
    transaction_id: input.transactionId, // A unique transaction ID for this purchase.
    value: input.priceCents / 100, // The total value of the transaction.
    currency: input.currency.toLocaleUpperCase(), // The currency of the transaction.
  })

  // @ts-ignore - TikTok
  window.ttq.track(
    'firstPurchase',
    {
      contents: [
        {
          content_id: input.transactionId,
          content_type: 'product',
          content_name: 'purchase',
        },
      ],
      value: input.priceCents / 100,
      currency: input.currency.toLocaleUpperCase(),
    },
    {
      event_id: `firstPurchase-${input.transactionId}`,
    },
  )
}
